export const PLATFORM_SELECTOR_TEST_ID = 'header-selector-test-id';
export const APPCUES_ID = {
    DIV_SELECTOR: 'DIV_SELECTOR',
};

export const ALL_ACCOUNTS_OPTION = {
    value: 'all',
    data: {
        id: 'all',
        type: 'client',
    },
    label: 'All accounts',
};
